import React from 'react';

const Pagination = () => {
  return (
    <ul className="flex my-4">
      <li className="mx-4 px-4 py-2 rounded border-transparent border hover:border-basic-orange hover:bg-white text-font-gray hover:text-basic-orange">
        Sebelum
      </li>
      <li className="mx-1 px-4 py-2 rounded border border-basic-orange bg-white text-basic-orange">
        1
      </li>
      <li className="mx-1 px-4 py-2 rounded border-transparent border hover:border-basic-orange hover:bg-white text-font-gray hover:text-basic-orange">
        2
      </li>
      <li className="mx-1 px-4 py-2 rounded border-transparent border hover:border-basic-orange hover:bg-white text-font-gray hover:text-basic-orange">
        3
      </li>
      <li className="mx-4 px-4 py-2 rounded border-transparent border hover:border-basic-orange hover:bg-white text-font-gray hover:text-basic-orange">
        Lanjut
      </li>
    </ul>
  );
};

export default Pagination;
